import MyLeavesFilters from '../../MyLeaves/Filters';

export default class Filters extends MyLeavesFilters {
}